import {ComponentProps} from "react";
import {Form, Input, Modal, ModalProps} from "antd";
import {useForm} from "antd/lib/form/Form";
import DatePicker from "../DatePicker";
import dayjs from "dayjs";
import {useSelector} from "react-redux";
import {RootState} from "../../models";
import Select from "../Select";



interface OrderContactModalProps extends ModalProps{
    onComplete?:Function
    contactOrderId?:number|string
}

function OrderContactModal(props:OrderContactModalProps) {
    const {contactOrderId, ...otherProps} = props;
    const userInfo = useSelector<RootState, RootState['auth']>(state => state.auth)?.user;
    const [form] = useForm();
    form.setFieldValue('orderId', contactOrderId);
    const onOk = (e:any)=>{
        form.validateFields().then(value => {
            otherProps.onComplete && otherProps.onComplete(value);
        });

        otherProps.onOk && otherProps.onOk(e);
    }

    return <Modal title={'联系记录'} open={!!contactOrderId} {...otherProps} onOk={onOk}>
        <Form form={form} layout={"vertical"}>
            <Form.Item noStyle name={'orderId'}/>
            <Form.Item name={'createTime'} initialValue={dayjs(Date.now())}>
                <DatePicker showTime/>
            </Form.Item>
            <Form.Item name={'createBy'} initialValue={userInfo?.id}>
                <Select url={'/user/dict'} getData={data => data.data} textField={'nickName'} valueField={'id'}/>
            </Form.Item>
            <Form.Item name={'content'} rules={[{required: true, message:'请填写联系结果'}]}>
                <Input.TextArea rows={3} placeholder={'请填写联系结果'}/>
            </Form.Item>
        </Form>
    </Modal>
}

export default OrderContactModal;